import React, { useState } from 'react';
import { Send, CheckCircle } from 'lucide-react';
import { contactInfo } from '../data/mockData';

const LeadForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    businessName: '',
    phone: '',
    fabricRequirement: '',
    quantity: '',
    city: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Format WhatsApp message
    const message = `
*New Inquiry from Website*

Name: ${formData.name}
Business: ${formData.businessName}
Phone: ${formData.phone}
Fabric Requirement: ${formData.fabricRequirement}
Quantity: ${formData.quantity}
City: ${formData.city}
    `.trim();

    // Redirect to WhatsApp
    const whatsappUrl = `https://wa.me/919713889720?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');

    // Reset form
    setFormData({
      name: '',
      businessName: '',
      phone: '',
      fabricRequirement: '',
      quantity: '',
      city: ''
    });
  };

  return (
    <section id="lead-form" className="py-16 bg-gray-900 relative overflow-hidden">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='1'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
        }}></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-3xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12 text-white">
            <h2 className="text-4xl lg:text-5xl font-bold mb-4">
              Get a <span className="text-accent">Free Quote</span>
            </h2>
          </div>

          {/* Form */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 lg:p-12">
            <form onSubmit={handleSubmit} className="space-y-6">
              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Your Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Enter your name"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Business Name
                  </label>
                  <input
                    type="text"
                    name="businessName"
                    value={formData.businessName}
                    onChange={handleChange}
                    className="form-input"
                    placeholder="Your business name"
                  />
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    Phone / WhatsApp <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="+91 XXXXX XXXXX"
                  />
                </div>

                <div>
                  <label className="block text-sm font-semibold text-gray-700 mb-2">
                    City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                    className="form-input"
                    placeholder="Your city"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Fabric Requirement <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="fabricRequirement"
                  value={formData.fabricRequirement}
                  onChange={handleChange}
                  required
                  rows="3"
                  className="form-input"
                  placeholder="Which fabric are you looking for? (e.g., 4-Way Zurich 260 GSM, Superpoly, Hosiery)"
                ></textarea>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">
                  Quantity
                </label>
                <input
                  type="text"
                  name="quantity"
                  value={formData.quantity}
                  onChange={handleChange}
                  className="form-input"
                  placeholder="e.g., 100 meters, 50 kg"
                />
              </div>

              <button
                type="submit"
                className="btn-primary btn-lg w-full flex items-center justify-center gap-2 group"
              >
                <Send size={20} />
                Send Inquiry via WhatsApp
                <CheckCircle size={20} className="opacity-0 group-hover:opacity-100 transition-opacity" />
              </button>

              <p className="text-center text-sm text-gray-600">
                Your inquiry will be sent directly to our WhatsApp for instant response
              </p>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadForm;
